import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import _ from 'lodash';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import { HBox, VBox } from '../../../../components/Box';
import { FormField } from '../../../../components/FormFields';
import { DecoratorLabel, Input } from '../../../../components/Input';
import { selectWorks } from '../../../Api/selectors';
import { selectLedgers, selectVatCodes } from '../../selectors';
import { REQUEST_PRODUCTS } from '../../../products/constants';
import { getLedgers, getVatCodes } from '../../actions';
import { BaseComponent } from '../../../../components/BaseComponent';
import { Loader } from '../../../../components/Loader';
import { INVOICE_DIRECTIONS, REQUEST_LEDGERS, REQUEST_VAT_CODES } from '../../constants';

import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './AddOneTimeProductModal.module.css';

import { Modal, ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { fixPriceFormat, getQuantOfDecimalPlaces } from '../../../../utils/string';

const Container = styled.div`
  .label {
    font-size: 16px;
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;
const STATE = {
  id: '',
  description: '',
  incl: true,
  vat_code: null,
  price_incl_vat: '',
  ledger: '',
  price_excl_vat: '',
  one_time: '',
  price: '',
  showNotificationModal: false,
  approveCancel: null,
};

class OneTimeProductComp2 extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.getVatCodes(() => {
      //SET Hooikammer default vat_code
      if (env.clientId === AppClientId.HOOIKAMMER) {
        this.onDropdownChange({ value: '01' }, 'vat_code', () => this.calculateProductPrices(INVOICE_DIRECTIONS.OUTGOING));
      }
    });
    this.props.getLedgers(result => {
      //SET Hooikammer default ledger
      if (env.clientId === AppClientId.HOOIKAMMER) {
        this.onDropdownChange({ value: '810299' }, 'ledger');
      }
    });

    if (this.props.currentManualProduct) {
      this.setState({
        id: this.props.currentManualProduct?.id,
        description: this.props.currentManualProduct?.description,
        incl: this.props.currentManualProduct?.incl,
        vat_code: this.props.currentManualProduct?.vat_code,
        price_incl_vat: this.props.currentManualProduct?.price_incl_vat,
        ledger: this.props.currentManualProduct?.ledger,
        price_excl_vat: this.props.currentManualProduct?.price_excl_vat,
        one_time: this.props.currentManualProduct?.one_time,
        price: this.props.currentManualProduct?.price,
      });
    }
  }

  get vatCodes() {
    return this.props.vatCodes ?? [];
  }

  get vatCodeOptions() {
    return this.vatCodes.map(vatCode => ({ value: vatCode.code, label: `${vatCode.code} : ${vatCode.description}` }));
  }

  getVatCodeLabel(direction, value) {
    const vatCodeValue = this.vatCodes.find(vatCode => vatCode?.code == value);

    return vatCodeValue?.code ? `${vatCodeValue?.code} : ${vatCodeValue?.description}` : null;
  }

  get ledgers() {
    return this.props.ledgers ?? [];
  }

  get ledgerOptions() {
    return this.ledgers.map(ledger => ({
      value: ledger.ledgerNumber,
      label: `${ledger.ledgerNumber} : ${ledger.description}`,
    }));
  }

  get requiredFields() {
    const types = ['description', 'vat_code', 'ledger', 'one_time'];

    return types.filter(type => !this.state[type]);
  }

  getLedgerLabel(direction, value) {
    const ledgerValue = this.ledgers.find(ledger => ledger?.ledgerNumber == value);

    return ledgerValue?.ledgerNumber ? `${ledgerValue?.ledgerNumber} : ${ledgerValue?.description}` : null;
  }

  isNoValid(property) {
    return this.requiredFields.includes(property);
  }

  formatString(string) {
    const replacedCommas = string?.toString()?.replace(',', '.');
    return parseFloat(replacedCommas);
  }

  onInputChange(evt, callback) {
    let value = evt.target.value;
    if (['price_excl_vat', 'price_incl_vat'].includes(evt.target.name) && getQuantOfDecimalPlaces(value) > 2) {
      return;
    }

    this.setState({ [evt.target.name]: value }, callback);
  }

  onDropdownChange(evt, name, callback) {
    this.setState({ [name]: evt.value }, callback);
  }

  onStringInputChange1(event) {
    const inputValue = event.target.value;

    if (inputValue.length <= 60) {
      this.setState({ name: inputValue });
    } else {
      alert('Het maximale aantal karakters van 60 is bereikt.');
    }
  }

  calculateProductPrices(direction, calcFromExcl = false) {
    calcFromExcl = true;
    this.setState({ isLoading: true });
    let exclPrice = this.formatString(this.state.price_excl_vat) || 0;
    let inclPrice = this.formatString(this.state.price_incl_vat) || 0;

    let totalPrice = this.state.price ?? 0;
    let totalPriceExclVat = this.state.priceExclVat ?? 0;
    let vatAmount = this.state.vatAmount;
    let quantity = this.state.one_time ?? 0;

    let vatCode = this.state.vat_code ?? null;
    let vatObj = this.props.vatCodes.find(v => v.code === vatCode) ?? { percentage: 0 };

    if (calcFromExcl) {
      inclPrice = _.round(exclPrice * (1 + vatObj.percentage), 2);
    }

    if (!calcFromExcl) {
      exclPrice = _.round(inclPrice / (1 + vatObj.percentage), 2);
    }
    totalPriceExclVat = _.round(exclPrice * quantity, 2);
    vatAmount = _.round(totalPriceExclVat * vatObj.percentage, 2);
    totalPrice = _.round(totalPriceExclVat + vatAmount, 2);

    this._t = this.timeout(
      () =>
        this.setState({
          price_excl_vat: fixPriceFormat(exclPrice) || 0,
          price_incl_vat: fixPriceFormat(inclPrice) || 0,
          price: fixPriceFormat(totalPrice),
          priceExclVat: fixPriceFormat(totalPriceExclVat),
          vatAmount: fixPriceFormat(vatAmount),
          isLoading: false,
        }),
      2500,
      this._t,
    );
  }

  get currentOneTimeProduct() {
    let id;
    if (this.props.currentManualProduct) {
      id = this.props.currentManualProduct.id;
    } else if (this.props.currentManualProduct?.currentSubject?.id) {
      id = this.props.currentManualProduct?.currentSubject?.id;
    } else {
      const length = this.props.secondaryManualProducts.length;
      id = `product_${length + 1}`;
    }

    let product = {
      id,
      description: this.state.description,
      incl: true,
      vat_code: this.state.vat_code,
      price_incl_vat: this.state.price_incl_vat,
      ledger: this.state.ledger,
      price_excl_vat: this.state.price_excl_vat,
      one_time: this.state.one_time,
      price: this.state.price,
    };
    if (this.props.currentManualProduct?.currentSubject) {
      product.currentSubject = this.props.currentManualProduct?.currentSubject;
    }

    return product;
  }

  onClose() {
    if (this.state.approveCancel == 'yes') {
      this.setState({ showNotificationModal: false });
      return this.props.onClose();
    }

    this.setState({ showNotificationModal: true });
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <ModalComponent className={styles.modal} title={this.lbl('confirm')} onClose={this.props.onClose}>
        {this.state.showNotificationModal && (
          <ModalComponent>
            <strong>{this.lbl('cancel.save_without_changes_notification')}</strong>

            <div className={styles.buttonContainer}>
              <ButtonComponent
                style={'ButtonSoftEdit'}
                onClick={() => this.setState({ approveCancel: 'yes' }, this.onClose.bind(this))}
              >
                {this.lbl('yes')}
              </ButtonComponent>
              <ButtonComponent style={'ButtonSoftDelete'} onClick={() => this.setState({ showNotificationModal: false })}>
                {this.lbl('no')}
              </ButtonComponent>
            </div>
          </ModalComponent>
        )}
        <>
          <div className={styles.container}>
            <label className="form-label">{this.lbl('product.productname')}</label>
            <input
              className="form-control text-muted"
              name="description"
              type="text"
              placeholder="product name"
              value={this.state.description}
              onChange={evt => {
                this.onInputChange(evt);
                this.onStringInputChange1(evt);
              }}
            />
            {this.isNoValid('description') && <RequireMark>*</RequireMark>}
          </div>

          <div className={styles.container}>
            <label className="form-label">{this.lbl('vehicle.property.vat_code')}</label>
            <SearchSelect
              name="vat_code"
              minWidth="70%"
              options={this.vatCodeOptions}
              placeholder={this.getVatCodeLabel('vatOut', this.state.vat_code) ?? 'vat'}
              value={
                this.getVatCodeLabel('vatOut', this.state.vat_code) && {
                  label: this.getVatCodeLabel('vatOut', this.state.vat_code),
                }
              }
              onChange={e => {
                this.onDropdownChange(e, 'vat_code', () => this.calculateProductPrices(INVOICE_DIRECTIONS.OUTGOING));
              }}
            />
          </div>

          <div className={styles.container}>
            <label className="form-label">{this.lbl('invoice.ledgers.column_ledger_description')}</label>
            <SearchSelect
              name="ledger"
              minWidth="70%"
              options={this.ledgerOptions}
              placeholder={this.getLedgerLabel('ledgerOut', this.state.ledger) ?? 'ledger'}
              value={
                this.getLedgerLabel('ledgerOut', this.state.ledger) && {
                  label: this.getLedgerLabel('ledgerOut', this.state.ledger),
                }
              }
              onChange={e => {
                this.onDropdownChange(e, 'ledger');
              }}
            />
          </div>

          <div className={styles.container}>
            <label className="form-label">{this.lbl('product.price_excl_vat')}</label>
            <div className={styles.inputPrice}>
              <input
                className="form-control text-muted"
                name="price_excl_vat"
                type="text"
                placeholder="price"
                value={this.state.price_excl_vat}
                onChange={evt => {
                  this.onInputChange(evt, () => this.calculateProductPrices(INVOICE_DIRECTIONS.OUTGOING, true));
                }}
              />
              <div className={styles.decoration}>€</div>
            </div>
          </div>

          <div className={styles.container}>
            <label className="form-label">{this.lbl('product.quantity')}</label>
            <input
              className="form-control"
              name="one_time"
              placeholder="quantity"
              type="text"
              value={this.state.one_time}
              onChange={evt => {
                this.onInputChange(evt, () => this.calculateProductPrices(INVOICE_DIRECTIONS.OUTGOING));
              }}
            />
            {this.isNoValid('one_time') && <RequireMark>*</RequireMark>}
          </div>
          {/* <div className={styles.container}>
            <label className="form-label">{this.lbl('product.price_incl_vat')}</label>
            <div className={styles.inputPrice}>
              <input
                className="form-control text-muted"
                name="price_incl_vat"
                type="text"
                placeholder="price"
                value={this.state.price_incl_vat}
                onChange={evt => {
                  this.onInputChange(evt, () => this.calculateProductPrices(INVOICE_DIRECTIONS.OUTGOING));
                }}
              />
              <div className={styles.decoration}>€</div>
            </div>
          </div> */}
          <HBox>
            <div className={styles.container}>
              <label className="form-label">{this.lbl('product.priceExclVat')}</label>
              <div className={styles.inputPrice}>
                <input
                  className="form-control"
                  name="priceExclVat"
                  type="text"
                  id="readOnlyInput"
                  readOnly
                  disabled
                  placeholder="priceExclVat"
                  value={this.state.priceExclVat}
                  onChange={evt => {
                    this.onInputChange(evt);
                  }}
                />
                <div className={styles.decoration}>€</div>
              </div>
            </div>
            <VBox right>
              <div className={styles.container}>
                <label className="form-label">{this.lbl('product.vatAmount')}</label>
                <div className={styles.inputPrice}>
                  <input
                    className="form-control"
                    name="vatAmount"
                    type="text"
                    id="readOnlyInput"
                    readOnly
                    disabled
                    placeholder="vatAmount"
                    value={this.state.vatAmount}
                    onChange={evt => {
                      this.onInputChange(evt);
                    }}
                  />
                  <div className={styles.decoration}>€</div>
                </div>
              </div>
              <div className={styles.container}>
                <label className="form-label">{this.lbl('product.price')}</label>
                <div className={styles.inputPrice}>
                  <input
                    className="form-control"
                    name="price"
                    type="text"
                    id="readOnlyInput"
                    readOnly
                    disabled
                    placeholder="price"
                    value={this.state.price}
                    onChange={evt => {
                      this.onInputChange(evt);
                    }}
                  />
                  <div className={styles.decoration}>€</div>
                </div>
              </div>
            </VBox>
          </HBox>
        </>

        <div className={styles.buttonContainer}>
          <ButtonComponent
            disabled={this.requiredFields.length}
            style={'ButtonSoftEdit'}
            onClick={() => this.props.onComplete(this.currentOneTimeProduct)}
          >
            {this.props.currentManualProduct ? this.lbl('update') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.onClose.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

OneTimeProductComp2.propTypes = {
  dispatch: PropTypes.func.isRequired,
  address: PropTypes.object,
  vehicle: PropTypes.object,
  reset: PropTypes.func,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vatCodes: selectVatCodes(),
    ledgers: selectLedgers(),
    work: selectWorks([REQUEST_PRODUCTS, REQUEST_VAT_CODES, REQUEST_LEDGERS]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    getVatCodes(callback) {
      dispatch(getVatCodes(callback));
    },
    getLedgers(callback) {
      dispatch(getLedgers(callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const AddOneTimeProductModal = compose(withConnect, withRouter, injectIntl)(OneTimeProductComp2);
